export const ENV = {
    ACCESS_ENDPOINT: process.env.REACT_APP_ACCESS_ENDPOINT
}

export default ENV